<template>
    <span v-if="parseInt(messageCount) > 0" class="badge" :class="classes">
        {{ messageCount }}
    </span>
</template>

<script>
import axios from 'axios';

export default {
    name: "UnreadMessagesCount",
    props: {
        count: {
            type: Number,
            required: true
        },
        classes: {
            type: String
        }
    },
    data: function () {
        return {
            messageCount: this.count,
        }
    },
    mounted() {
        if (! window.Echo) {
            return;
        }

        window.Echo.private('messages.' + window.Laravel.user.id)
            .listen('.message.created', (e) => {
                this.getUnreadMessagesCount();
            })
            .listen('.messages.read', (e) => {
                this.getUnreadMessagesCount();
            });
    },
    methods: {
        getUnreadMessagesCount() {
            axios.get(`/messages/unread-count`).then(result => {
                this.messageCount = result.data.count;
            }).catch(error => {
                console.log(error);
            })
        }
    }
}
</script>
